import { Vue, Component } from 'vue-property-decorator'
import declOfNum from '~/utils/declOfNum'
import LinkSelector from '~/components/element/LinkSelector'
import LinkItem from '~/types/LinkItem'
import * as count from '~/utils/config/productCount'
import * as sort from '~/utils/config/productSort'
import s from '~/utils/s'

@Component
export default class UserProductHeader extends Vue {
  get textProduct (): string {
    return declOfNum(s(this.$store).userProductList.list.userProductListDataAll.length, [
      'список',
      'списка',
      'списков'
    ])
  }

  get selectedSort (): string {
    const query = this.$route.query
    return sort.checkValue(query.sort)
  }

  get sortList (): LinkItem[] {
    const query = this.$route.query
    const get = (sortCode: string, name: string) => (
      {
        code: sortCode,
        title: name,
        location: {
          path: this.$route.path,
          query: {
            ...query,
            sort: sortCode
          }
        }
      }
    )

    return Object.entries(sort.default).map(([k, v]) => get(k, v))
  }

  mounted(){
    s(this.$store).unknownPage.changeShowSticky(true);
  }

  beforeDestroy(){
    s(this.$store).unknownPage.setShowSticky(false)
  }
  
  render () {
    if (s(this.$store).userProductList.list.userProductListDataAll.length > 0) {
      return (
        <div class="entity-list-header">
          <div class="entity-list-header__content">
            <h1 class="entity-list-header__content-header">
              Мои списки
            </h1>
            <div class="entity-list-header__content-count">
              {s(this.$store).userProductList.list.userProductListDataAll.length}&nbsp;{this.textProduct}
            </div>
          </div>
          <div class="entity-list-header__sort user-list">
          Сортировать:
            <div class="entity-list-header__sort-product">
              <LinkSelector {...{
                props: {
                  items: this.sortList,
                  selected: this.selectedSort
                }
              }} />
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div class="entity-list-header">
          <div class="entity-list-header__content">
            <h1 class="entity-list-header__content-header">
              Мои списки отсутствуют
            </h1>
          </div>
        </div>
      )
    }
  }
}
